import { defineComponent as r, computed as a, openBlock as s, createElementBlock as c, createElementVNode as t, toDisplayString as f, createCommentVNode as d, normalizeStyle as n, createStaticVNode as p } from "vue";
const v = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "314f0589-f5ab-41f9-a060-fac4844984a2" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), _ = { mask: "url(#314f0589-f5ab-41f9-a060-fac4844984a2)" }, k = { key: 0 }, u = /* @__PURE__ */ p('<path fill="#0052b4" d="M256 0h256v512H0V256Z"></path><path fill="#eee" d="M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z"></path><path fill="#d80027" d="M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z"></path><path fill="#496e2d" d="M445.2 256.1zm-155.8 0z"></path><path fill="#eee" d="M433 293.6a62.4 62.4 0 0 0 12.2-37.5V144.8a55.4 55.4 0 0 1-33.4 11.1 55.6 55.6 0 0 1-44.5-22.2 55.6 55.6 0 0 1-44.5 22.2 55.4 55.4 0 0 1-33.4-11.1v111.3c0 15 5 27.3 12.3 37.5h131.2z"></path><path fill="#ff9811" d="M409.8 235.5a91 91 0 0 0 6.3-27.6c0-10.1-13.2-18.3-13.2-18.3s-13.2 8.2-13.2 18.3a91 91 0 0 0 6.3 27.6l-7.6 17.1a38.3 38.3 0 0 0 29 0zm-51.5-55.6a91 91 0 0 0-27 8.3c-8.8 5-9.3 20.5-9.3 20.5s13.7 7.4 22.4 2.3c5.5-3.1 15-11.8 20.8-19.2l18.6-2a38.4 38.4 0 0 0-4.7-14 38.4 38.4 0 0 0-9.7-11.1zm-22.4 72.2a91 91 0 0 0 20.7 19.3c8.8 5 22.5-2.3 22.5-2.3s-.6-15.5-9.3-20.5a91 91 0 0 0-27-8.4l-11.1-15.1a38.4 38.4 0 0 0-9.7 11 38.4 38.4 0 0 0-4.8 14z"></path><path fill="#338af3" d="M299 289.5c20.7 33.3 68.3 44.5 68.3 44.5s47.6-11.2 68.4-44.5H298.9Z"></path>', 7), g = { fill: "none" }, V = ["r"], M = /* @__PURE__ */ r({
  __name: "ai",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(i) {
    const e = i, l = a(() => 512 + 2 * e.strokeWidth), o = a(() => -e.strokeWidth), h = a(() => 256 + e.strokeWidth / 2);
    return (z, x) => (s(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${o.value} ${o.value} ${l.value} ${l.value}`
    }, [
      m,
      t("g", _, [
        e.flagName ? (s(), c("title", k, f(e.flagName), 1)) : d("", !0),
        u
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: h.value,
          fill: "none",
          style: n({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, V)
      ])
    ], 8, v));
  }
});
export {
  M as default
};
//# sourceMappingURL=ai-a832c151.js.map
